import { render, staticRenderFns } from "./NotificationsWidget.vue?vue&type=template&id=298726aa&scoped=true&"
import script from "./NotificationsWidget.vue?vue&type=script&lang=js&"
export * from "./NotificationsWidget.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsWidget.vue?vue&type=style&index=0&id=298726aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298726aa",
  null
  
)

export default component.exports